import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalInstance';
import { UserGroupsProvider } from './contexts/UserGroupsContext';

const App: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [msalReady, setMsalReady] = useState(false);

  useEffect(() => {
    async function initMsal() {
      await msalInstance.initialize();
      await msalInstance.handleRedirectPromise();
      setMsalReady(true);
    }
    initMsal();
  }, []);

  if (!msalReady) {
    return <div>Loading authentication...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <UserGroupsProvider>
        {children}
      </UserGroupsProvider>
    </MsalProvider>
  );
};

export default App;